import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function MechanismSection() {
  const steps = [{
    number: '01',
    title: 'Página guiada',
    desc: 'Para sacar el veneno sin caer en el bucle mental.'
  }, {
    number: '02',
    title: 'Acción física',
    desc: 'Para bajar la carga del cuerpo inmediatamente.'
  }, {
    number: '03',
    title: 'Micro-cierre',
    desc: 'Para no negociar contigo misma en la madrugada.'
  }];
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-6 relative overflow-hidden" data-id="element-160">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-161">
        <div className="text-center mb-16" data-id="element-162">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xs font-bold tracking-widest text-gradient uppercase mb-4 block" data-id="element-163">
            El Método
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-heading font-bold text-white" data-id="element-164">
            Ritual de Urgencia (RU)
          </motion.h2>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-20" data-id="element-165">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="glass-card p-8 rounded-2xl hover:border-[#E8636F]/30 transition-colors duration-300 group" data-id="element-166">
              <div className="text-4xl font-heading font-bold text-white/10 group-hover:text-gradient transition-all duration-300 mb-4" data-id="element-167">
                {step.number}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-168">
                {step.title}
              </h3>
              <p className="text-[#A8A8B3] leading-relaxed" data-id="element-169">{step.desc}</p>
            </motion.div>)}
        </div>

        {/* Phone Mockup Section */}
        <div className="max-w-sm mx-auto relative" data-id="element-170">
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          bounce: 0.4
        }} className="relative z-10" data-id="element-171">
            <div className="bg-[#1C1C1E] rounded-[3rem] border-8 border-[#2C2C2E] p-4 shadow-2xl overflow-hidden" data-id="element-172">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-[#2C2C2E] rounded-b-xl z-20" data-id="element-173"></div>

              <div className="pt-12 pb-8 px-4 h-[400px] flex flex-col bg-[#000000]" data-id="element-174">
                <div className="text-center text-[#8E8E93] text-xs font-medium mb-8" data-id="element-175">
                  Today 23:48
                </div>

                <div className="flex justify-end mb-2" data-id="element-176">
                  <div className="bg-[#0A84FF] text-white px-4 py-2 rounded-2xl rounded-tr-sm max-w-[80%] text-sm" data-id="element-177">
                    ¿estás bien?
                  </div>
                </div>
                <div className="text-right text-[10px] text-[#8E8E93] mb-8" data-id="element-178">
                  Delivered
                </div>

                <div className="mt-auto" data-id="element-179">
                  <div className="w-full h-10 rounded-full border border-[#3A3A3C] flex items-center px-4 text-[#8E8E93] text-sm" data-id="element-180">
                    iMessage
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Glow behind phone */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[#E8636F] opacity-20 blur-[80px] rounded-full pointer-events-none" data-id="element-181"></div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center mt-12" data-id="element-182">
          <p className="text-xl text-white font-medium mb-8" data-id="element-183">
            Qué haces a las 11:48pm cuando tu dedo ya está sobre enviar.
          </p>
          <Button onClick={scrollToPricing} className="px-8 py-3" data-id="element-184">
            Necesito el protocolo
          </Button>
        </motion.div>
      </div>
    </section>;
}